import React, { useState } from 'react';
import './Header.css';
import shef from '../assets/shef.png';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const targetElement = document.querySelector(href);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    // Close menu on mobile after clicking a link
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img width={22} height={30} src={shef} alt="FoodQuick" className="logo-image" />
            <span className="logo-text">FoodQuick</span>
          </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <a href="#features" className="nav-link" onClick={(e) => handleLinkClick(e, '#features')}>Özellikler</a>
            <a href="#recipes" className="nav-link" onClick={(e) => handleLinkClick(e, '#recipes')}>Tarifler</a>
            <a href="#download" className="nav-link" onClick={(e) => handleLinkClick(e, '#download')}>İndir</a>
            <a href="#contact" className="nav-link" onClick={(e) => handleLinkClick(e, '#contact')}>İletişim</a>
          </nav>
          
          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
